import React, { Component } from 'react';
import cn from 'classnames';
import { combined } from '../shared/status';
import './columns.scss';

class Player extends Component {
  static displayName = 'List';

  constructor(props) {
    super(props);

    this.renderContainer = this.renderContainer.bind(this);
    this.ItemContainer = this.ItemContainer.bind(this);
  }

  /*
   * Renders component main element
   * */
  renderContainer(props) {
    const { scrolling, print, children } = props;
    return (
      <div
        className={cn('columns', { scrolling }, { 'columns--print': print })}
      >
        {children}
      </div>
    );
  }

  /**
   * Renders item container
   * */
  ItemContainer(props) {
    const { index, children } = props;
    return (
      <div className="column" key={index}>
        {children}
      </div>
    );
  }

  render() {
    const { childPlayer } = this.props;
    const { print } = this.props.context;
    const { items, scrolling } = this.props.item.content;

    const Container = this.renderContainer;
    const ItemContainer = this.ItemContainer;

    return (
      <Container scrolling={scrolling} print={print}>
        {items.map((child, index) => (
          <ItemContainer key={index}>{childPlayer(index, child)}</ItemContainer>
        ))}
      </Container>
    );
  }
}

export default { Player, status: combined };
